module.exports = __webpack_public_path__ + "edf48bb9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_tag/Column/bg_02.jpg
// module id = 1262
// module chunks = 2